/**
 *
 */
const getStyleObjWithMargins = (props) => {
    const style = {}
    if (props.marginY) {
        style.marginTop = `${props.marginY}px`
        style.marginBottom = `${props.marginY}px`
    }
    if (props.marginTop) {
        style.marginTop = `${props.marginTop}px`
    }
    if (props.marginBottom) {
        style.marginBottom = `${props.marginBottom}px`
    }

    return style
}

/**
 *
 */
export {
    getStyleObjWithMargins
}
